import React, {useEffect, useState} from 'react';
import {Button, Modal, notification} from 'antd';
import {MODALS} from 'utils/constants';
import {useDispatch, useSelector} from 'react-redux';
import {setActiveModal} from '../../store/global/actions';
import './ResetPassword.scss';
import GlobalApi from 'services/Global';

export const ResetPassword = () => {
    const dispatch = useDispatch();
    const {activeModal, user} = useSelector(({global}) => global);

    const forgotPwd = async () => {
        const res = await GlobalApi.forgotPassword({emailId: user?.emailId});
        if (res) {
            notification.success({
                message: 'Success',
                description: res.message,
            });
        }
        dispatch(setActiveModal(null));
    };

    const onAccept = async () => {
        forgotPwd();
    };

    const onDecline = async () => {
        dispatch(setActiveModal(null));
    };

    return (
        <Modal
            centered={window.innerWidth > 1024 ? true : false}
            title={
                <div>
                    <div
                        style={{
                            color: '#A3A2A2',
                            fontSize: window.innerWidth > 576 ? '17px' : '15px',
                        }}
                    >
                        DBS Insights Direct - Reset Password
                    </div>
                </div>
            }
            visible={activeModal === MODALS.RESET_PASSWORD}
            closable={false}
            onCancel={() => onDecline()}
            destroyOnClose
            cancelText="Skip"
            okText="Reset Password"
            onOk={() => onAccept()}
            wrapClassName="reset-modal"
            maskStyle={{
                backdropFilter: 'blur(6px)',
                background: '#fff0',
            }}
            // className="reset-modal"
            data-testid="disclaimer-modal-1"
            maskClosable={false}
            // footer={null}
            // bodyStyle={{height: 120}}
        >
            <div className="password-reset">
                <p>
                    Your password has expired.Kindly reset your password below.
                </p>
                {/* <div className="password-reset--btn">
                    <Button onClick={() => forgotPwd()}>Forgot Password</Button>
                </div> */}
            </div>
        </Modal>
    );
};
